import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import theOneImage from '../assets/images/p2.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={theOneImage} alt="Avatar" className="avatar-image" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/ChahiriAbderrahmane" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/chahiri-abderrahmane/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
            <h1 style={{ whiteSpace: 'nowrap' }}>Chahiri Abderrahmane</h1>
          <p>Full Stack Data Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/ChahiriAbderrahmane" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/chahiri-abderrahmane/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;